let shopHostname = window.location.hostname;
if (shopHostname.startsWith("client") || shopHostname.startsWith("localhost")) {
  shopHostname = "https://new.staging.carus-verlag.com";
} else {
  shopHostname = "https://www.carus-verlag.com";
}

export default {
  // product display information
  product: {
    name: "carus performance portal",
    version: "25.5.27.0",
    gitsha: "ff64685c9538b02c717fe43044bd9f16f7fd8f89",
    shopHostname,
  },

};
